const Kategoriya2312 = () => {
    return (
        <div style={{ fontFamily: "Times New Roman", fontSize: "14pt" }} className="container mt-5">
            <h3 className="text-center text-primary">
                2-sinf 3-chorak<br />
                Mavzu: Gap<br />
“Oson” bo‘limidagi topshiriqlar va ularni o‘tkazish metodikasi
            </h3>
            <b>1-mashq. Quyidagi so‘zlarga mos qo‘shimchalar qo‘shib, birikmalar hosil qiling.</b><br />
            <i>Ta’limiy maqsad:</i> O‘quvchilarning so‘z birikmalari haqidagi ko‘nikmalarini rivojlantirish.<br />
            <i>Mashg‘ulot davomiyligi:</i> 3-4 daqiqa <br />
            <p>Kitob___ varag‘__</p>
            <p>Shamol____ esish__</p>
            <p>O‘rik___ meva__</p>
            <p>Onam___ qaradi__</p>
            <p><b>2-mashq. Juftlikda ishlang. Aralash berilgan so‘zlardan gaplar hosil qiling, kerakli o‘rinlarga qo‘shimchalar qo‘ying.</b></p>
            <p><i>Ta'limiy maqsad:</i>O‘quvchilarning gaplar ustida ishlash ko‘nikmalarini rivojlantirish.</p>
            <p><i>Mashg‘ulot davomiyligi:</i>3-4 daqiqa</p>
            <p className="text-break">gullar, hidla, chiroyli, rohatlanasan
_______________________________________________________________
</p>
            <p className="text-break">bobo, qunduz, hamisha, bilan, biz, ertak, yashaydi 
____________________________________________________________
</p>
            <p><b>3-mashq. Gaplarni mantiqan davom ettiring. </b></p>
            <p><i>Ta’limiy maqsad:</i>O‘quvchilarning bog‘lanishli nutqini rivojlantirish ko‘nikmalarini rivojlantirish.</p>
            <p><i>Mashg‘ulot davomiyligi:</i>3-4 daqiqa.</p>
            <p className="text-break">Vrachning vazifasi bemorni davolash bo‘lib, ____________________________</p>
            <p className="text-break">Bog‘bon bog‘ni sug‘oradi, __________________________________________</p>
        </div>
    )
}
export default Kategoriya2312;